/* Cria · interações de produto
   1. Inclinação 3D com reflexo de luz seguindo o mouse (computador).
   2. No celular, a segunda foto aparece sozinha quando o card de destaque para no meio da tela.
   3. Transição da foto do card até a página do produto (navegadores com View Transitions). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* 1. inclinação 3D */
  if (fine && !reduce) {
    document.addEventListener('pointermove', function (e) {
      var el = e.target.closest && e.target.closest('[data-tilt]');
      if (!el) return;
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      el.style.setProperty('--rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
      el.style.setProperty('--ry', ((x - 0.5) * 9).toFixed(2) + 'deg');
      el.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
      el.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      el.classList.add('is-tilting');
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var el = e.target.closest && e.target.closest('[data-tilt]');
      if (!el || (e.relatedTarget && el.contains(e.relatedTarget))) return;
      el.classList.remove('is-tilting');
      el.style.removeProperty('--rx'); el.style.removeProperty('--ry');
    }, { passive: true });
  }

  /* 2. celular: segunda foto nos destaques */
  if (!fine && !reduce && 'IntersectionObserver' in window) {
    var timers = new WeakMap();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var el = en.target;
        clearTimeout(timers.get(el));
        if (en.isIntersecting) timers.set(el, setTimeout(function () { el.classList.add('is-peek'); }, 900));
        else el.classList.remove('is-peek');
      });
    }, { rootMargin: '-30% 0px -30% 0px', threshold: 0.2 });
    var watch = function () {
      document.querySelectorAll('.pair__card, .best__card').forEach(function (el) {
        if (el.dataset.peek) return; el.dataset.peek = 1;
        if (el.querySelector('.pm--swap')) io.observe(el);
      });
    };
    watch();
    document.addEventListener('shopify:section:load', watch);
  }

  /* 3. foto do card vira a foto da página do produto */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    var box = a.closest('.card, .pair__card, .best__card');
    if (!box) return;
    var img = box.querySelector('.pm-main') || box.querySelector('.card__media img, .pair__media img, .media img');
    document.querySelectorAll('[data-vt]').forEach(function (n) { n.style.viewTransitionName = ''; n.removeAttribute('data-vt'); });
    if (img) { img.style.viewTransitionName = 'cria-prod'; img.setAttribute('data-vt', ''); }
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-vt]').forEach(function (n) { n.style.viewTransitionName = ''; n.removeAttribute('data-vt'); });
  });
})();
